import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useContent } from "../context/ContentContext";
import { useTranslation } from "../hooks/useTranslation";

const Navbar = () => {
  const { user, logOut } = UserAuth();
  const navigate = useNavigate();
  const { categories, series } = useContent();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const { t, currentLanguage, setLanguage } = useTranslation();

  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setSearchResults([]);
      return;
    }

    const filteredResults = series
      .filter((s) => s.title.toLowerCase().includes(searchTerm.toLowerCase()))
      .map((s) => {
        const isLive = s.episodes?.some((ep) => ep.isLive) || false;
        return {
          ...s,
          isLive,
          categoryName: categories.find((c) => c.id === s.categoryId)?.name,
        };
      });

    setSearchResults(filteredResults);
  }, [searchTerm, series, categories]);

  const handleResultClick = (seriesId) => {
    navigate(`/series/${seriesId}`);
    setSearchTerm("");
    setSearchResults([]);
    setSearchOpen(false);
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between p-4 z-[100] w-full absolute">
      <Link to="/">
        <img
          className="w-30 h-16 sm:h-20 md:h-20 object-cover"
          src={`/ringette_live_logo.png?${new Date().getTime()}`}
          alt="Ringette.Live Logo"
          onError={(e) => {
            console.error("Failed to load image:", e.target.src);
            e.target.src = "/path/to/placeholder.png";
          }}
        />
      </Link>
      <div
        className={`relative flex items-center ${
          searchOpen ? "mt-4 sm:mt-0" : ""
        }`}
      >
        {!searchOpen ? (
          /*           <FaSearch
            className="text-white cursor-pointer"
            onClick={() => setSearchOpen(true)}
          /> */
          <></>
        ) : (
          <div className="relative flex items-center">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="p-2 w-48 sm:w-64 border border-gray-300 rounded pl-10"
              placeholder={t("searchPlaceholder")}
              autoFocus
            />
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer" />
            <FaTimes
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
              onClick={() => {
                setSearchOpen(false);
                setSearchTerm("");
                setSearchResults([]);
              }}
            />
            {searchResults.length > 0 && (
              <ul className="bg-white border border-gray-300 rounded-b max-h-64 overflow-y-auto absolute top-12 left-0 w-48 sm:w-64">
                {searchResults.map((result) => (
                  <li
                    key={result.id}
                    className="p-2 cursor-pointer hover:bg-gray-200 flex justify-between items-center"
                    onClick={() => handleResultClick(result.id)}
                  >
                    <span>{result.title}</span>
                    {result.isLive && (
                      <p className="absolute right-4 bg-red-600 text-white text-xs px-2 py-1 rounded">
                        {t("live")}
                      </p>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
        <div className="text-right ml-2 sm:ml-4">
          <button
            onClick={() => setLanguage(currentLanguage === "en" ? "fr" : "en")}
            className="mr-3 bg-gray-700 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs"
            title={t("switchLanguage")}
          >
            {currentLanguage === "en" ? "FR" : "EN"}
          </button>
          {user?.email ? (
            <>
              <Link to="/account">
                <button className="text-white py-2 pr-2 sm:pr-4">
                  {t("account")}
                </button>
              </Link>
              <button
                onClick={handleLogout}
                className="bg-black px-4 sm:px-6 py-2 rounded cursor-pointer text-white"
              >
                {t("logout")}
              </button>
            </>
          ) : (
            <>
              <Link to="/login">
                <button className="text-white pr-2 sm:pr-4">
                  {t("signIn")}
                </button>
              </Link>
              <Link to="/signup">
                <button className="bg-black px-4 sm:px-6 py-2 rounded cursor-pointer text-white">
                  {t("signUp")}
                </button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
